module.exports = __webpack_public_path__ + "assets/d77ae2acb57c331402f6244da599509b.png";